module.exports = __webpack_public_path__ + "static/media/arrow_curved.515a79ff.svg";